import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.renewContract.1";
import { IExtraData } from "./schema.renewContract.types";
import { getInitialValues } from "./schema.renewContract.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
